"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.areAnalyticsCookiesEnabled = exports.arePreferenceCookiesEnabled = exports.areCookiesAccepted = exports.acceptCookies = exports.registerOnDisableCookieCallback = exports.registerOnAllowCookieCallback = exports.LS_KEY_COOKIES = void 0;
exports.LS_KEY_COOKIES = "edaz-cookies-preferences";
var PREFERENCE_COOKIES_KEY = "preferenceCookies";
var ANALYTICS_COOKIES_KEY = "analyticsCookies";
function registerOnAllowCookieCallback(type, callBack) {
    window.addEventListener("storage", function (e) {
        if (e.key === exports.LS_KEY_COOKIES) {
            if ((type === "preference" && arePreferenceCookiesEnabled()) || (type === "analytics" && areAnalyticsCookiesEnabled())) {
                callBack();
            }
        }
    });
}
exports.registerOnAllowCookieCallback = registerOnAllowCookieCallback;
function registerOnDisableCookieCallback(type, callBack) {
    window.addEventListener("storage", function (e) {
        if (e.key === exports.LS_KEY_COOKIES) {
            if ((type === "preference" && !arePreferenceCookiesEnabled()) || (type === "analytics" && !areAnalyticsCookiesEnabled())) {
                callBack();
            }
        }
    });
}
exports.registerOnDisableCookieCallback = registerOnDisableCookieCallback;
function acceptCookies(preference, analytics) {
    var _a;
    if (preference === void 0) { preference = true; }
    if (analytics === void 0) { analytics = true; }
    var value = JSON.stringify((_a = {},
        _a[PREFERENCE_COOKIES_KEY] = preference,
        _a[ANALYTICS_COOKIES_KEY] = analytics,
        _a));
    localStorage[exports.LS_KEY_COOKIES] = value;
    window.dispatchEvent(new StorageEvent("storage", { key: exports.LS_KEY_COOKIES, newValue: value }));
}
exports.acceptCookies = acceptCookies;
function areCookiesAccepted() {
    return !!(localStorage[exports.LS_KEY_COOKIES]);
}
exports.areCookiesAccepted = areCookiesAccepted;
function arePreferenceCookiesEnabled() {
    if (localStorage[exports.LS_KEY_COOKIES]) {
        var cookieSettings = JSON.parse(localStorage[exports.LS_KEY_COOKIES]);
        return cookieSettings[PREFERENCE_COOKIES_KEY];
    }
    return false;
}
exports.arePreferenceCookiesEnabled = arePreferenceCookiesEnabled;
function areAnalyticsCookiesEnabled() {
    if (localStorage[exports.LS_KEY_COOKIES]) {
        var cookieSettings = JSON.parse(localStorage[exports.LS_KEY_COOKIES]);
        return cookieSettings[ANALYTICS_COOKIES_KEY];
    }
    return false;
}
exports.areAnalyticsCookiesEnabled = areAnalyticsCookiesEnabled;
